import dayjs from "dayjs";
import { Dayjs } from 'dayjs'

const relativeTime = require("dayjs/plugin/relativeTime");
require("dayjs/locale/ru");
require("dayjs/locale/en");

dayjs.extend(relativeTime);
type DateType = string | number | Date | Dayjs

declare module 'dayjs' {
    interface Dayjs {
        fromNow(withoutSuffix?: boolean): string
        from(compared: DateType, withoutSuffix?: boolean): string
        toNow(withoutSuffix?: boolean): string
        to(compared: DateType, withoutSuffix?: boolean): string
    }
}

export default function getFromNow(dt: Date | undefined) {
    if (dt) {
        return dayjs(dt).fromNow(true);
    }
    return null;
};
